module.exports = __webpack_public_path__ + "static/media/5083b4b5a163b456731e82e1c8357c29_html_1b412ba2e27b5cb7.a4e3a468.png";